import { type MoveEvent, TYPE_MASK, WALL, lavaIn, LAVA_EVERY } from '@chessbut/engine';
import type { VariantUi } from './ui.ts';

const LAVA = '/art/lava.svg';
const lavaAdded = (e: MoveEvent) => e.t === 'add' && e.cause === 'lava';

export const lavaUi: VariantUi = {
  heroImage: '/art/volcano.svg',
  peek: [{ image: LAVA }, {}, { image: '/art/bK.svg' }, {}, { image: LAVA }, { image: LAVA }, { image: '/art/wR.svg' }, {}, {}],

  pieceImage(_pos, _sq, piece) {
    return (piece & TYPE_MASK) === WALL ? LAVA : null;
  },

  pieceLabel(_pos, _sq, piece) {
    return (piece & TYPE_MASK) === WALL ? 'lava' : null;
  },

  twist(pos) {
    const n = lavaIn(pos);
    return {
      text: n === 1 ? 'A square turns to lava after this move!' : `Another square turns to lava in ${n} moves`,
      pips: { on: LAVA_EVERY - n, total: LAVA_EVERY, title: 'Moves until the next lava square' },
      alert: n === 1,
    };
  },

  eventSound(e) {
    return lavaAdded(e) ? 'sizzle' : null;
  },

  moveBadge(rec) {
    return rec.events.some(lavaAdded) ? { icon: LAVA, title: 'A square turned to lava' } : null;
  },
};
